import { createSlice } from "@reduxjs/toolkit";

const focusSlice = createSlice({
  name: "focus",
  initialState: {
    focusedField: null as string | null,
  },
  reducers: {
    setFocusedField: (state, action) => {
      state.focusedField = action.payload;
    },
    clearFocusedField: (state) => {
      state.focusedField = null;
    },
  },
});

export const { setFocusedField, clearFocusedField } = focusSlice.actions;
export default focusSlice.reducer;
